// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq {\n  padding-left: 100px !important;\n  padding-top: 36px;\n  border-top: 5px solid var(--ion-color-secondary);\n  height: 100%;\n}\n\n.faqItem {\n  --min-height:66px;\n}\n\n.pointerCursor {\n  cursor: pointer !important;\n}\n\n.defaultCursor {\n  cursor: default;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
